module.exports = __webpack_public_path__ + "iPhone11-Yellow@2x.png?0a14d0201ed9f4d6708b6ba21329e7d4";